import moment from 'moment'

export const timestampToDate = timestamp => moment(timestamp).format('YYYY-MM-DD')

export const timestampToDateTime = timestamp => moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
